import { Component, TemplateRef, ViewChild, ChangeDetectorRef, ElementRef, AfterViewInit, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PlanProtectionService } from '../../service/plan-protection/plan-protection.service';
import { SpinnerService } from '../../service/spinner-service/spinner.service';
import { WebcamDialogComponent } from '../../../app/dialogs/webcam-dialog/webcam-dialog.component';
import { HistorialServicioDialogComponent } from '../../../app/dialogs/historial-servicio-dialog/historial-servicio-dialog';
import { SeleccionarServiciosModalComponent } from '../../../app/dialogs/seleccionar-servicios-dialog/seleccionar-servicios-dialog.component';
import { ServiciosSeleccionadossModalComponent } from '../../../app/dialogs/servicios-seleccionados-dialog/servicios-seleccionados-dialog.component';
import { SeleccionarSucursalModalComponent } from '../../../app/dialogs/seleccionar-sucursal/seleccionar-sucursal-dialog.component';
import { InformationDialogComponent } from '../../../app/dialogs/information-dialog/information-dialog.component';
import { SkuInfoDialogComponent } from '../../../app/dialogs/sku-info/sku-info-dialog.component';
import { environment } from '../../../environments/environment';

export interface InspectionZone {
  llantasId: number;
  id: string;
  label: string;
  x: number;
  y: number;
  width: number;
  height: number;
  selectorX: number;
  selectorY: number;
  selected: boolean;
  cx: number;
  cy: number;
  radius: number;
  completeLabel: string,
  type: 'tire' | 'plate';
}

@Component({
  selector: 'app-carro-interactivo',
  templateUrl: './carro-interactivo.html',
  styleUrls: ['./carro-interactivo.scss']
})

export class CarroInteractivoComponent { 

  constructor(private ppService: PlanProtectionService, private dialog: MatDialog, private cdr: ChangeDetectorRef, private spinnerService: SpinnerService){
    
  }

  onSelectionChange(selected: number[]) { }

  @Input() planPro: any
  @Output() cambiarSeccion = new EventEmitter<any>();
  
  inventario = false
  existenciaInventario = 0
  banderaInicial = true
  servicios = [
    {
      "servicioSkuId": 13728,
      "label": "Rotaciones",
      "descripcion": "Rotaciones",
      "iconClass": "balanceo",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "rotacion",
      "img": "../../../assets/icons/balanceo.png"
    },
    {
      "servicioSkuId": 13729,
      "label": "Balanceos",
      "descripcion": "Balanceos",
      "iconClass": "parchado",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "balanceo",
      "img": "../../../assets/icons/parchado.png"
    },
    {
      "servicioSkuId": 13730,
      "label": "Diag. Mecánico",
      "descripcion": "Diagnóstico Mecánico",
      "iconClass": "diagnostico-mecanico",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "diagnostico",
      "img": "../../../assets/icons/diagnostico-mecanico.png"
    },
    {
      "servicioSkuId": 13732,
      "label": "Nitrógeno",
      "descripcion": "Llenado de Nitrógeno",
      "iconClass": "nitrogeno",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "nitrogeno",
      "img": "../../../assets/icons/nitrogeno.png"
    },
    {
      "servicioSkuId": 13733,
      "label": "Parchado",
      "descripcion": "Servicio de Parchado",
      "iconClass": "rotaciones",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "parchado",
      "img": "../../../assets/icons/rotacion.png"
    },
    {
      "servicioSkuId": 38662,
      "label": "Garantía",
      "descripcion": "Garantía",
      "iconClass": "garantia",
      "cantidadTotal": 0,
      "cantidadDisponible": 0,
      "variable": "garantia",
      "img": "../../../assets/icons/garantia.png"
    }
  ]

  serviciosLlantas = [
    {
      llantaId: 2,
      label: 'Llanta Delantera Izquierda',
      parchado: 0,
      nitrogeno: 0,
      garantia: 0,
      balanceo: 0,
      rotacion: 0,
      diagnostico: 0,
      serviciosSeleccionados: []
    },
    {
      llantaId: 1,
      label: 'Llanta Delantera Derecha',
      parchado: 0,
      nitrogeno: 0,
      garantia: 0,
      balanceo: 0,
      rotacion: 0,
      diagnostico: 0,
      serviciosSeleccionados: []
    },
    {
      llantaId: 3,
      label: 'Llanta Trasera Izquierda',
      parchado: 0,
      nitrogeno: 0,
      garantia: 0,
      balanceo: 0,
      rotacion: 0,
      diagnostico: 0,
      serviciosSeleccionados: []
    },
    {
      llantaId: 4,
      label: 'Llanta Trasera Derecha',
      parchado: 0,
      nitrogeno: 0,
      garantia: 0,
      balanceo: 0,
      rotacion: 0,
      diagnostico: 0,
      serviciosSeleccionados: []
    }
  ]
  kilometraje
  base64Tacometro
  ppCaducado = false
  deducibleCero = false
  zones: InspectionZone[] = [
    { llantasId: 2, id: 'tire-fl', label: 'D-IZQ', completeLabel: 'Llanta Delantera Izquierda', x: 25, y: 150, width: 92, height: 92, selectorX: 0, selectorY: 240, selected: false, type: 'tire', cx: 40, cy: 44, radius: Math.min(92, 92) / 2},
    { llantasId: 1, id: 'tire-fr', label: 'D-DER', completeLabel: 'Llanta Delantera Derecha', x: 475, y: 150, width: 80, height: 80, selectorX: -60, selectorY: 240, selected: false, type: 'tire', cx: 44, cy: 40, radius: Math.min(92, 92) / 2 },
    { llantasId: 3, id: 'tire-rl', label: 'T-IZQ', completeLabel: 'Llanta Trasera Izquierda', x: 25, y: 445, width: 80, height: 80, selectorX: 0, selectorY: 220, selected: false, type: 'tire', cx: 40, cy: 44, radius: Math.min(92, 92) / 2 },
    { llantasId: 4, id: 'tire-rr', label: 'T-DER', completeLabel: 'Llanta Trasera Derecha', x: 475, y: 445, width: 80, height: 80, selectorX: -60, selectorY: 220, selected: false, type: 'tire', cx: 44, cy: 44, radius: Math.min(92, 92) / 2 },
    // { id: 'plate-front', label: 'NO SERIE', completeLabel: 'Número de Serie', x: 200, y: 150, width: 200, height: 50, selectorX: 20, selectorY: 220, selected: false, type: 'plate' },
    // { id: 'plate-rear', label: 'PLACA TRASERA', completeLabel: 'Placa Trasera/Delantera', x: 200, y: 680, width: 200, height: 50, selectorX: 20, selectorY: 220, selected: false, type: 'plate' }
  ];

  // Usamos SVGSVGElement para evitar el error de getScreenCTM
  @ViewChild('svgRef') svgRef!: ElementRef<SVGSVGElement>;

  isEditing = false;
  private activeZone: InspectionZone | null = null;
  private dragOffset = { x: 0, y: 0 };
  
  // Variable para diferenciar un "tap" de un "drag" en móviles
  private isDragging = false;

  get hasDamage(): boolean { return this.zones.some(z => z.selected); }

  get selectedZonesText(): string {
    return this.zones
      .filter(z => z.selected)
      .map(z => z.type === 'tire' ? `Llanta ${z.label}` : z.label)
      .join(', ');
  }

  getTextY(zone: InspectionZone): number {
    if (zone.type === 'plate' && zone.id.includes('rear')) return 70;
    if (zone.type === 'tire' && (zone.id.includes('rl') || zone.id.includes('rr'))) return 105;
    return -10;
  }

  isTire(zone){
    if (!zone.id.includes('tire')){
      return false
    }else{
      return true
    }
  }

  // --- INTERACCIÓN ---

  toggleZone(zone: InspectionZone, event: Event): void {
    // En móviles, el evento click a veces dispara conflictos con touch.
    // Usamos handleTap para touch, y este click queda para mouse.

    let selects = this.serviciosLlantas.find(item => item.llantaId === zone.llantasId)?? null;
    const dialogRef = this.dialog.open(SeleccionarServiciosModalComponent, {
      panelClass: 'custom-dialog',
      disableClose: true,
      width: '100vw',
      height: 'auto',
      maxHeight: '720px',
      data: {
        title: zone.completeLabel,
        llantaId: zone.llantasId,
        serviciosSeleccionados: selects,
        servicios: this.servicios,
        inventario: this.inventario,
        existenciaInventario: this.existenciaInventario
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(!!result){
        
        if(result.event === 1){
          let selects = this.serviciosLlantas.find(item => item.llantaId === result.llantaId)?? null;
          const auxServs = this.serviciosLlantas.filter(item => item.llantaId !== result.llantaId);
          const selectsAux = selects

          // disminuuye la cantidada. redimir y setea en 1 los que se seleccionaron
          result.serviciosSeleccionados.forEach(element => {
            let serv = this.servicios.find(item => item.servicioSkuId === element.servicioSkuId);

            selectsAux[element.variable] === 1 ? '' : serv.cantidadDisponible --
            if(serv.servicioSkuId === 13728 || serv.servicioSkuId === 13729 || serv.servicioSkuId === 13730 ){
              this.serviciosLlantas.forEach(allUpdate => {
                allUpdate[element.variable] = 1
              });
              auxServs.forEach((auxServ, index) => {
                let auxS = auxServ.serviciosSeleccionados.find(item => item.servicioSkuId === serv.servicioSkuId)
                if(auxS === undefined){
                  auxServs[index].serviciosSeleccionados.push(serv)
                  // if(auxS.servicioSkuId === environment.garantiaServicioId){
                  //   this.existenciaInventario --
                  // }
                }
              });
            }
            if(selects.garantia !== 1 && serv.servicioSkuId === environment.garantiaServicioId){
              this.existenciaInventario --
            }
            selects[element.variable] = 1
          });

          const resultado = this.servicios.filter( item1 => !result.serviciosSeleccionados.some(item2 => item2.servicioSkuId === item1.servicioSkuId) );

          // aumenta la cantidada. redimir y setea en 0 los que no se seleccionaron
          resultado.forEach(element => {
            let serv = this.servicios.find(item => item.servicioSkuId === element.servicioSkuId);

            selectsAux[element.variable] === 0 ? '' : serv.cantidadDisponible ++
            if(serv.servicioSkuId === 13728 || serv.servicioSkuId === 13729 || serv.servicioSkuId === 13730 ){
              this.serviciosLlantas.forEach(allUpdate => {
                allUpdate[element.variable] = 0
              });
              auxServs.forEach((auxServ, index) => {
                let auxS = auxServ.serviciosSeleccionados.find(item => item.servicioSkuId === serv.servicioSkuId)
                if(auxS !== undefined){
                  auxServs[index].serviciosSeleccionados = auxServs[index].serviciosSeleccionados.filter( item => item.servicioSkuId !== serv.servicioSkuId );
                  // if(auxS.servicioSkuId === environment.garantiaServicioId){
                  //   this.existenciaInventario ++
                  // }
                }
              });
            }
            if(selects.garantia !== 0 && serv.servicioSkuId === environment.garantiaServicioId){
              this.existenciaInventario ++
            }
            selects[element.variable] = 0
          });

          selects.serviciosSeleccionados = result.serviciosSeleccionados
        }
      }
    });
    // if (this.isEditing) return;
    event.stopPropagation();
  }

  getZoneSelected(zone){
    let selects = this.serviciosLlantas.find(item => item.llantaId === zone.llantasId)?? null;
    return  selects.serviciosSeleccionados.length > 0 ? true : false
  }

  // Manejo especial para Touch en móviles (evita seleccionar al terminar de arrastrar)
  handleTap(zone: InspectionZone, event: Event): void {
    // Si estábamos arrastrando, no contamos esto como un click de selección
    if (this.isDragging && this.isEditing) return;
    
    // Si es un evento touch puro que no fue drag, lo contamos como click
    // Nota: (click) usualmente funciona bien en móvil, pero esto es un seguro
    if (window.matchMedia("(pointer: coarse)").matches) {
       // Opcional: lógica específica para móvil si 'click' falla
    }
  }

  toggleEditMode(): void {
    this.isEditing = !this.isEditing;
    this.activeZone = null;
  }

  // --- DRAG (MOUSE Y TOUCH UNIFICADOS) ---

  startDrag(event: MouseEvent | TouchEvent, zone: InspectionZone): void {
    if (!this.isEditing) return;
    
    // Importante para evitar scroll en móviles mientras arrastras
    if (event.cancelable) event.preventDefault();
    
    this.isDragging = false;
    this.activeZone = zone;
    
    const pt = this.getClientPoint(event);
    this.dragOffset.x = pt.x - zone.x;
    this.dragOffset.y = pt.y - zone.y;
  }

  onMove(event: MouseEvent | TouchEvent): void {
    if (!this.activeZone || !this.isEditing) return;
    
    if (event.cancelable) event.preventDefault();
    this.isDragging = true;

    const pt = this.getClientPoint(event);
    this.activeZone.x = pt.x - this.dragOffset.x;
    this.activeZone.y = pt.y - this.dragOffset.y;
  }

  endDrag(): void {
    this.activeZone = null;
    setTimeout(() => { this.isDragging = false; }, 100);
  }

  // --- MATEMÁTICAS RESPONSIVAS ---
  
  // Esta función unifica la obtención de coordenadas X/Y sea Mouse o Touch
  private getClientPoint(event: MouseEvent | TouchEvent) {
    const svg = this.svgRef.nativeElement;
    // CTM convierte coordenadas de pantalla a coordenadas internas del SVG
    const CTM = svg.getScreenCTM(); 
    
    let clientX, clientY;

    if (event instanceof MouseEvent) {
      clientX = event.clientX;
      clientY = event.clientY;
    } else {
      // Es TouchEvent
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    }

    if (!CTM) return { x: 0, y: 0 };

    return {
      x: (clientX - CTM.e) / CTM.a,
      y: (clientY - CTM.f) / CTM.d
    };
  }

  abrirHistorial(opc, name){
    let auxArray = []
    let body ={
      EmpresaId: this.planPro.empresaId,
      OrdenVentaPlanProtectionId: this.planPro.ordenVentaPlanProtectionId,
      SkuPlanProtection: this.planPro.skuPlanProtection
    }

    let serv = this.servicios.find(item => item.servicioSkuId === opc);
    this.ppService.getHistorialGarantia(body).subscribe(
      data => {
        data.fechas.forEach(element => {
          if(element.servicioSkuId === opc){
            
            let auxFilespath = element.filesPaths.filter(filePath => !filePath.includes('.pdf'));

            let existeHistorial
            if(serv.servicioSkuId === 13728 || serv.servicioSkuId === 13729 || serv.servicioSkuId === 13730){
              existeHistorial = auxArray.some(
                el => el.servicioSkuId === serv.servicioSkuId && el.fecha === element.fechaUso
              );
            }
            
            if(existeHistorial){
            }else{
              auxArray.unshift({
                servicioSkuId: serv.servicioSkuId,
                descripcion: serv.descripcion,
                iconClass: serv.iconClass,
                filespaths: auxFilespath,
                fecha: element.fechaUso,
                usuario: element.nombreUsuario !== '' ? element.nombreUsuario : 'Sin información',
                cliente: element.cliente !== '' ? element.cliente : 'Sin información',
                sucursal: element.nombreSucursal !== '' ? element.nombreSucursal : 'Sin información'
              })
            }
            // auxArray.unshift({
            //   servicioSkuId: serv.servicioSkuId,
            //   descripcion: serv.descripcion,
            //   filespaths: auxFilespath,
            //   iconClass: serv.iconClass,
            //   fecha: element.fechaUso,
            //   usuario: element.nombreUsuario,
            //   cliente: element.cliente,
            //   sucursal: element.nombreSucursal
            // })
          }
          
        });

        this.dialog.open(HistorialServicioDialogComponent, {
          width: '424px',
          maxHeight: '80vh',
          panelClass: 'custom-dialog',
          data: {
            historial: auxArray,
            name: name
          }
        });
      }
    )
  }

  abrirDetalleSku(){
    const dialogRef = this.dialog.open(SkuInfoDialogComponent, {
      width: '424px',
      maxHeight: '80vh',
      panelClass: 'custom-dialog',
      data: {
        ppDetalle: this.planPro,
        carrito: this.serviciosLlantas,
        inventario: this.inventario,
        title: 'Servicios Seleccionados'
      }
    });
  }

  abrirCarrito(){
    const dialogRef = this.dialog.open(ServiciosSeleccionadossModalComponent, {
      width: '424px',
      maxHeight: '80vh',
      panelClass: 'custom-dialog',
      data: {
        ppDetalle: this.planPro,
        base64Tacometro: this.base64Tacometro,
        kilometraje: this.kilometraje,
        carrito: this.serviciosLlantas,
        inventario: this.inventario,
        title: 'Servicios Seleccionados'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(!!result){
        if(result.event === 1){
          this.serviciosLlantas = [
            {
              llantaId: 2,
              label: 'Llanta Delantera Izquierda',
              parchado: 0,
              nitrogeno: 0,
              garantia: 0,
              balanceo: 0,
              rotacion: 0,
              diagnostico: 0,
              serviciosSeleccionados: []
            },
            {
              llantaId: 1,
              label: 'Llanta Delantera Derecha',
              parchado: 0,
              nitrogeno: 0,
              garantia: 0,
              balanceo: 0,
              rotacion: 0,
              diagnostico: 0,
              serviciosSeleccionados: []
            },
            {
              llantaId: 3,
              label: 'Llanta Trasera Izquierda',
              parchado: 0,
              nitrogeno: 0,
              garantia: 0,
              balanceo: 0,
              rotacion: 0,
              diagnostico: 0,
              serviciosSeleccionados: []
            },
            {
              llantaId: 4,
              label: 'Llanta Trasera Derecha',
              parchado: 0,
              nitrogeno: 0,
              garantia: 0,
              balanceo: 0,
              rotacion: 0,
              diagnostico: 0,
              serviciosSeleccionados: []
            }
          ]
        }
        if(result.event === 4){
          this.deducibleCero = true
          let body ={
            EmpresaId: this.planPro.empresaId,
            OrdenVentaPlanProtectionId: this.planPro.ordenVentaPlanProtectionId,
            SkuPlanProtection: this.planPro.skuPlanProtection
          }

          this.serviciosLlantas = [
            {
              llantaId: 2,
              label: 'Llanta Delantera Izquierda',
              parchado: 0,
              nitrogeno: 0,
              garantia: 0,
              balanceo: 0,
              rotacion: 0,
              diagnostico: 0,
              serviciosSeleccionados: []
            },
            {
              llantaId: 1,
              label: 'Llanta Delantera Derecha',
              parchado: 0,
              nitrogeno: 0,
              garantia: 0,
              balanceo: 0,
              rotacion: 0,
              diagnostico: 0,
              serviciosSeleccionados: []
            },
            {
              llantaId: 3,
              label: 'Llanta Trasera Izquierda',
              parchado: 0,
              nitrogeno: 0,
              garantia: 0,
              balanceo: 0,
              rotacion: 0,
              diagnostico: 0,
              serviciosSeleccionados: []
            },
            {
              llantaId: 4,
              label: 'Llanta Trasera Derecha',
              parchado: 0,
              nitrogeno: 0,
              garantia: 0,
              balanceo: 0,
              rotacion: 0,
              diagnostico: 0,
              serviciosSeleccionados: []
            }
          ]
          this.ppService.getHistorialGarantia(body).subscribe(
            data => {
              data.detallePP.forEach(element => {
                let serv = this.servicios.find(item => item.servicioSkuId === element.servicioSkuId);

                serv.cantidadDisponible = element.cantidad - element.usos
                // serv.cantidadDisponible = 2
                serv.cantidadTotal = element.cantidad
              });
              this.spinnerService.hide()
            }
          )
        }
      }
    });
  }

  mandarSenal() {
    this.cambiarSeccion.emit('general');
  }

  setSucursalActual(){
    const dialogRef = this.dialog.open(SeleccionarSucursalModalComponent, {
      panelClass: 'custom-dialog',
      width: "90vw",
      disableClose: true,
      data: {
        planDetalle: this.planPro
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(!!result){
        if(result.event === 4){
         this.mandarSenal() 
        }
        if(!result.success){
          this.ppCaducado = true
        }else{
          this.ppCaducado = false
          this.kilometraje = result.kilometraje
          this.base64Tacometro = result.base64Tacometro
          this.getInventario()
        }
      }
    });

    
  }
  
  getInventario(){
    let body = {
      sucursalId: localStorage.getItem('sucursal_id'),
      empresaId: localStorage.getItem('sucursal_empresa_id'),
      sku: this.planPro.sku
    }
    this.ppService.getInventario(body).subscribe(
      data => {
        if(data.code === 400){
          this.inventario = false
          this.existenciaInventario = 0
          const dialogRef = this.dialog.open(InformationDialogComponent, {
            panelClass: 'custom-dialog',
            width: "90vw",
            disableClose: true,
            data: {
              title: 'No puedes aplicar garantía por falta de inventario de ' + this.planPro.sku,
              confirmText: 'Cerrar',
              warning: true
            }
          });
        }else{
          this.inventario = true
          this.existenciaInventario = data.existencia
        }
      }
    )
  }

  ngOnChanges(changes: SimpleChanges) {
      if (changes['planPro']) {
        if(this.banderaInicial){
          
          let body ={
            EmpresaId: this.planPro.empresaId,
            OrdenVentaPlanProtectionId: this.planPro.ordenVentaPlanProtectionId,
            SkuPlanProtection: this.planPro.skuPlanProtection
          }
          this.banderaInicial = false
          this.setSucursalActual()
          this.ppService.getHistorialGarantia(body).subscribe(
            data => {
              data.detallePP.forEach(element => {
                let serv = this.servicios.find(item => item.servicioSkuId === element.servicioSkuId);

                serv.cantidadDisponible = element.cantidad - element.usos
                // serv.cantidadDisponible = 2
                serv.cantidadTotal = element.cantidad
              });

              
            }
          )
        }
      }
    }
}
